module.exports = __webpack_public_path__ + "static/media/logo_white.d1ca26f0.png";